import React from 'react';
export const WordItem = ({ word }) => {
    return (React.createElement("div", { className: "word-item__row" },
        React.createElement("div", { className: "word-item__answer" },
            React.createElement("h5", null, word.answer)),
        React.createElement("div", { className: "word-item__clue" },
            React.createElement("h5", null, word.clue))));
};
